import React, { useEffect, useState } from 'react';
import facultyLogo from '../../assets/mora-logo.png';
import '../styles.css';

const ServerStatus = () => {
  const [servers, setServers] = useState([]);

  const fetchServerStatus = async () => {
    try {
      const response = await fetch('https://hardware-ping-testing-2.onrender.com/server-status'); // ✅ Updated URL
      if (!response.ok) throw new Error('Network response was not ok');
      const data = await response.json();
      setServers(data);
    } catch (error) {
      console.error('Error fetching server status:', error);
    }
  };

  useEffect(() => {
    fetchServerStatus(); // Initial fetch
    const interval = setInterval(fetchServerStatus, 3000); // Poll every 3s
    return () => clearInterval(interval);
  }, []);

  const renderIcon = (name) => {
    const lower = name.toLowerCase();
    if (lower.includes('faculty')) {
      return <img src={facultyLogo} alt="Faculty Logo" className="status-logo" />;
    }
    if (lower.includes('cloud')) {
      return <span className="status-icon cloudflare-icon">☁️</span>;
    }
    return <span className="status-icon invalid-icon">🚫</span>;
  };

  return (
    <div className="main-content">
      <div className="status-container">
        <h2>Server Status</h2>
        {servers.length > 0 ? (
          servers.map((server) => (
            <div key={server.ip} className="status-card">
              {renderIcon(server.name)}
              <div className="status-info">
                <p style={{fontSize:'18px'}}>{server.name} ({server.ip})</p>
                <p style={{ color: 'black', textAlign: 'initial',fontSize:'18px'}}>
                  Status: <span className={`status-${server.status}`}>
                    {server.status.toUpperCase()}
                  </span>
                </p>
              </div>
            </div>
          ))
        ) : (
          <p>Loading server statuses...</p>
        )}
      </div>
    </div>
  );
};

export default ServerStatus;
